import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchLandingData = args => {
    return doDefaultFetch(`https://api-web.nhle.com/v1/gamecenter/${args.gameId}/landing`, {
        isPublic: true,
        ...args
    });
};

const getSummaryFromLandingData = landingData => landingData?.summary;

export default {
    fetchLandingData,
    getSummaryFromLandingData,
};
